var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],class:_vm.__class,attrs:{"id":_vm._comId,"type":"hidden","name":_vm.name,"data-submit":_vm.getSubmit},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing)return;_vm.value=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }